// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { _AccountItemSelected } from '../elements/Lookup/TerceraAccountLookup';
import { DataCache } from '@shared/commons/DataCache';
import { Resources } from '@shared/localizations/Resources';
import { LookUpComponentView, LookUpProps, LookUpViewModel } from './LookUpViewModel';
import { AccountLookupDropDownFormProps } from './AccountLookupDropDownFormViewModel';
import { ContextEvents, contextHandler } from '../ReactControls/Handlers/ContextHandler';
export class AccountLookUpProps extends LookUpProps {
}
export class AccountLookUpComponentView extends LookUpComponentView {
}
export class AccountLookUpViewModel extends LookUpViewModel {
    constructor() {
        super(AccountLookUpComponentView);
    }
    getButtonTooltip() {
        return Resources.getResource('chart.ChartPanel.accountLookup.ToolTip');
    }
    showDropDowmForm(mainContainerRef) {
        const dropDownProps = this.getDropDownFormProps(mainContainerRef);
        contextHandler.emit(ContextEvents.OpenAccountLookupDropDownForm, dropDownProps);
        this.props.onDropDownFormOpened();
    }
    lookupErrorHideShow(isShow) {
        super.lookupErrorHideShow(isShow);
        if (isShow) {
            this.showPopupError(Resources.getResource('TerceraAccountLookup.AccountNotExist'), Resources.getResource('TerceraAccountLookup.IncorrectAccount'));
        }
    }
    getTypingLookupValueForSet(textValueId) {
        if (textValueId === 'All') {
            return this.props.ItemAll;
        }
        return DataCache.GetAccountById(textValueId);
    }
    dropDownFormCallBack(result) {
        const len = Array.isArray(result) ? result.length : 0;
        if (len !== 0) {
            if (len === 1) {
                this.onSelectItem(result[0]);
            }
            else if (len === DataCache.getNumberOfAccounts()) {
                this.onSelectItem(this.props.ItemAll);
            }
            else if (len < DataCache.getNumberOfAccounts()) {
                this.onSelectItem(new _AccountItemSelected(result));
            }
        }
        else {
            this.onSelectItem(result);
        }
    }
    isNeedSkeepItem(item) {
        return item.isMAM && !this.props.showMAM;
    }
    getDropDownFormProps(mainContainerRef, props) {
        let dropDownProps = new AccountLookupDropDownFormProps();
        dropDownProps = super.getDropDownFormProps(mainContainerRef, dropDownProps);
        const selectedItem = this.props.selectedItem;
        if (this.props.selectedItem.multiSelected) {
            dropDownProps.selectedItem = selectedItem.arraySelected;
        }
        else if (selectedItem === this.props.ItemAll) {
            dropDownProps.selectedItem = dropDownProps.items;
        }
        else {
            dropDownProps.selectedItem = selectedItem;
        }
        dropDownProps.showMAM = this.props.showMAM;
        return dropDownProps;
    }
}
